import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, BrainCircuit, MessageCircle, CheckSquare, FileText } from 'lucide-react';
import { CTAButton } from './CTAButton';
const DELIVERABLES = [{
  icon: BookOpen,
  title: 'Ebook Completo "Obediencia Sin Gritos"',
  desc: 'La guía paso a paso desde los 2 hasta los 12 años.'
}, {
  icon: BrainCircuit,
  title: 'Manual de Neuro-Comandos por Edades',
  desc: 'Estrategias exactas para el cerebro impulsivo (2-4), social (5-8) y autónomo (9-12).'
}, {
  icon: MessageCircle,
  title: 'El Diccionario de Guiones Rápidos',
  desc: 'Qué decir palabra por palabra en los 15 momentos más críticos (baño, comida, sueño, pantallas).'
}, {
  icon: CheckSquare,
  title: 'Checklist de Auditoría de Gritos',
  desc: 'Para identificar tus detonantes antes de que el grito escape.'
}, {
  icon: FileText,
  title: 'Hoja de Trabajo de Consecuencias Lógicas',
  desc: 'Para dejar de castigar y empezar a educar.'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-sage-50" data-id="element-114">
      <div className="max-w-4xl mx-auto px-6" data-id="element-115">
        {/* Mechanism */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-116">
          <div className="inline-flex items-center justify-center p-3 bg-sage-100 rounded-full mb-6" data-id="element-117">
            <BrainCircuit className="w-8 h-8 text-sage-700" data-id="element-118" />
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-navy mb-6" data-id="element-119">
            El Método de los Neuro-Comandos
          </h2>
          <p className="text-lg md:text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed" data-id="element-120">
            Este sistema no se basa en "ser amable" o dejar que el niño haga lo
            que quiera. Se basa en la{' '}
            <strong data-id="element-121">neurociencia aplicada a la crianza latina</strong>. En lugar
            de usar el volumen de tus pulmones, utilizas guiones específicos
            diseñados para atravesar la barrera emocional del niño y llegar
            directamente a su centro de cooperación. Aprenderás a dar
            instrucciones que el cerebro infantil, por su propia biología, no
            puede ignorar.
          </p>
        </motion.div>

        {/* Deliverables */}
        <div className="mb-16" data-id="element-122">
          <h3 className="font-serif text-2xl md:text-3xl text-navy mb-8 text-center" data-id="element-123">
            Lo que obtienes hoy
          </h3>
          <div className="grid gap-4 md:grid-cols-2" data-id="element-124">
            {DELIVERABLES.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className={`bg-white p-6 rounded-2xl shadow-sm border border-sage-100 flex gap-4 ${index === 0 ? 'md:col-span-2 bg-sage-600 text-white border-none' : ''}`} data-id="element-125">
                  <div className={`shrink-0 ${index === 0 ? 'text-sage-200' : 'text-sage-500'}`} data-id="element-126">
                    <Icon className="w-8 h-8" data-id="element-127" />
                  </div>
                  <div data-id="element-128">
                    <h4 className={`font-bold text-lg mb-1 ${index === 0 ? 'text-white' : 'text-stone-900'}`} data-id="element-129">
                      {item.title}
                    </h4>
                    <p className={index === 0 ? 'text-sage-100' : 'text-stone-600'} data-id="element-130">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>

        <div className="text-center" data-id="element-131">
          <CTAButton data-id="element-132" />
        </div>
      </div>
    </section>;
}